// Configuration Frontend
const config = {
  API_URL: process.env.REACT_APP_API_URL || '',
  DISCORD_LOGIN_URL: '/api/auth/discord',
};

export default config;
